module.exports = __webpack_public_path__ + "img/elecam-group-logo.3829fabd.png";